import { Component, ViewChild, Inject, ElementRef, ViewEncapsulation } from '@angular/core';

declare var Swiper;

@Component({
    selector: 'swiper-component',
    templateUrl: './swiper.html',
    styleUrls: ['./swiper.scss']
})
export class SwiperComponent {

	private swiperOptions: any = {
		direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 5,
    freeMode: false,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
	};
	private swiper: any;

  constructor( @Inject(ElementRef) private elementRef: ElementRef) {
  }

  ngOnInit() {
  	setTimeout(() => {
	  	this.swiper = new Swiper(this.elementRef.nativeElement.children[0], this.swiperOptions);
		});
  }
}


// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/components/swiper/swiper.ts